import { render } from "./Review.vue?vue&type=template&id=9398e8ea"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__